import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { updateUserTeam } from '../../Api/authApi.js.js';
import { updateUser } from '../../redux/authSlice.js';
import { toast } from 'react-toastify';
import '../updateuser/updateuser.css';

const Updateequipe = () => {
    const [teamCode, setTeamCode] = useState('');
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const user = useSelector((state) => state.auth.user);

    const handleUpdate = async () => {
        try {
            const response = await updateUserTeam(user.id, teamCode);
            if (response.success) {
                toast.success(response.message);
                dispatch(updateUser({ team_id: response.team_id }));
                navigate('/profil');
            } else {
                toast.warning(response.message || "Erreur lors de la mise à jour de l'équipe.");
            }
        } catch (error) {
            toast.warning(error.message || "Erreur lors de la mise à jour de l'équipe.");
        }
    };

    return (
        <div className="settings-form-page">
            <div className="sfp-header">
                <button className="sfp-back-btn pill-tap" onClick={() => navigate('/profil')}>
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                        <path d="M10 3L5 8l5 5" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                </button>
                <span className="sfp-page-title">Changer d'équipe</span>
            </div>

            <div className="sfp-body">
                <p className="sfp-subtitle">Entre le code de ta nouvelle équipe</p>

                <div className="sfp-card relief">
                    <div className="sfp-field">
                        <span className="sfp-field-icon">
                            <svg width="18" height="18" viewBox="0 0 16 16" fill="currentColor">
                                <path d="M7 14s-1 0-1-1 1-4 5-4 5 3 5 4-1 1-1 1zm4-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6m-5.784 6A2.24 2.24 0 0 1 5 13c0-1.355.68-2.75 1.936-3.72A6.3 6.3 0 0 0 5 9c-4 0-5 3-5 4s1 1 1 1zM4.5 8a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5"/>
                            </svg>
                        </span>
                        <input
                            className="sfp-input"
                            type="text"
                            name="team_code"
                            value={teamCode}
                            onChange={(e) => setTeamCode(e.target.value)}
                            placeholder="Code d'équipe"
                            onKeyDown={(e) => e.key === 'Enter' && handleUpdate()}
                        />
                    </div>

                    <button className="sfp-submit pill-tap" onClick={handleUpdate}>
                        Confirmer
                    </button>
                </div>
            </div>
        </div>
    );
};

export default Updateequipe;
